import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

class ForumFindOnePost extends baseRequest {
    constructor(postId, forumConfiguration, successHandler, failureHandler) {
        super();
        this.name = 'ForumFindOnePost';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.postId = postId;
        this.forumConfiguration = forumConfiguration;
        this.successHandler = successHandler;
        this.failureHandler = failureHandler;
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(`posts/${this.postId}`, {}, 'get', {
            basePath: this.forumConfiguration.apiPath,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            stringifyData: true,
        });
    }

    onSuccess() {
        this.successHandler(this.response);
    }

    onFailure(response, methodName = '') {
        super.onFailure(response, methodName);
        this.failureHandler();
    }

    handleServerError(error) {
        // super.handleServerError(error);
        this.failureHandler();
    }
}

export default ForumFindOnePost;
